import { Loader, PageBox, Row, StyledIconButton } from "../../../components";
import { useNewMigration } from "../../../hooks";
import styled from "@emotion/styled";
import { COLOURS } from "../../../shared";
import { Plus, Zap } from "lucide-react";

const NewMigration = () => {
  const { handleNewMigrationClick, isLoading } = useNewMigration();
  
  const IconWrapper = styled.div`
    width: 5.6rem;
    height: 5.6rem;
    border-radius: 50%;
    background-color: ${COLOURS.newMigrationIconWrapperBackground};
    display: flex;
    justify-content: center;
    align-items: center;
  `;

  const StyledParagraph = styled.p`
    font-size: ${(props) => props.theme.fontSize.emphasis}
  `;

  return (
    <>
      <PageBox isExistingMigration={false} padding="6.4rem">
        <Row maxHeight={10}>
          <IconWrapper>
            <Zap
              color={COLOURS.newMigrationIconColor}
              strokeWidth={2}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",              
              }}
            />
          </IconWrapper>
        </Row>
        <Row maxHeight={5}>
          <h1>Start your first import</h1>
        </Row>
        <Row>
          <StyledParagraph>
            Get a quick start to importing Contact and Matter data. You can
            start and stop this process at any time but once you have submitted
            an import it is irreversible.
          </StyledParagraph>
        </Row>
        <Row maxHeight={20}>
          <StyledIconButton
            disabled={false}
            text="New import"
            icon={<Plus size={16} className="icon" />}
            onClick={() => handleNewMigrationClick()}
          />
        </Row>
      </PageBox>
      {isLoading && <Loader />}
    </>
  );
};

export { NewMigration };
